/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createEntityAdapter } from '@reduxjs/toolkit';

import { Skill, SkillType } from '../../../../ts/skill';

// Entity Adapter
export const entityAdapter = createEntityAdapter<Skill>({
  selectId: (skill: Skill) => {
    // Before processing the ID, change the skill in-place such that if it
    // is of type dialog with a settings saying it's an action skill, just
    // set the type to be action and remove the now unused dialog setting.
    // This is probably a hack, but once Store returns Action skills with
    // a type of "action," we can remove this code.
    if (
      skill.type === SkillType.DIALOG &&
      skill.dialog_settings?.actions === true
    ) {
      skill.type = SkillType.ACTION;
      delete skill.dialog_settings?.actions;
    }
    return skill.skill_id;
  },
  sortComparer: (a, b) => (a.name || '').localeCompare(b.name)
});
